import * as Namespaces from './namespaces'
import {API, API_DOMAIN, API_PORT} from "../../helpers/constants";

const locales = {
    [Namespaces.PAGE_LOGIN]: {
        el: {
            'Unauthorized': 'Ο χρήστης δεν έχει πρόσβαση στην ιστοσελίδα.',
            "Attempt to read property \"isActive\" on null": "Πρέπει πρώτα να επαληθεύσετε την ηλεκτρονική σας διεύθυνση για να συνδεθείτε. Ελέγξτε το email σας.",
            'Unauthorized. Wrong Username or Password': 'Ο χρήστης δεν έχει πρόσβαση στην ιστοσελίδα. Ελέγξετε ότι το όνομα χρήστη και ο κωδικός σας είναι σωστά.',
            'Inactive User': 'Ανενεργός Χρήστης',
            'Access failed!': `Η πρόσβαση στο ${API} απέτυχε! Παρακαλώ ελέγξτε το δίκτυό σας και το firewall. Η πρόσβαση στο port ${API_PORT} του domain ${API_DOMAIN} πρέπει να είναι ανοιχτή για να συνεχίσετε.`,
            'Sign In': 'Είσοδος',
            required: 'Συμπληρώστε το πεδίο',
            User: 'Χρήστης',
            Password: 'Κωδικός',
            login: 'ΣΥΝΔΕΣΗ',
            'Login': 'Σύνδεση',
            reset: 'ΕΠΑΝΑΦΟΡΑ',
            CANCEL: 'ΑΚΥΡΩΣΗ',
            loading: 'Φόρτωση',
            'Forgot your password?': 'Ξεχάσατε τον κωδικό;',
            'reset_password_message': 'Συμπληρώστε το email σας και ακολουθήστε τις οδηγίες.',
            'Press here': 'Πατήστε εδώ',
            'Network Error': 'Σφάλμα δικτύου.',
            'Unauthenticated.': 'Χωρίς εξουσιοδότηση.',
            Username: 'Όνομα Χρήστη',
            'Reset Password': 'Επαναφορά Κωδικού',
            'Fill in your email and you will receive a message to reset your password.': 'Συμπληρώστε το email σας και θα λάβετε ένα μήνυμα για να επαναφέρετε τον κωδικό πρόσβασής σας.',
            Send: 'Αποστολή',
            'Enter a valid email': 'Εισαγάγετε έγκυρο email',
            'Forgot password?': 'Ξεχάσατε τον κωδικό σας;',
            'Don\'t have an account? Sign Up': 'Δεν έχετε λογαριασμό;',
            'Create': 'Δημιουργία',
            'Create Account': 'Δημιουργία Λογαριασμού',
            'Confirm Password': 'Επαλήθευση Κωδικού',
            'Submit': 'ΚΑΤΑΧΩΡΙΣΗ',
            'The email you entered was not found!': 'Δεν βρέθηκε το email που καταχωρίσατε!',
            'Already have an account?': 'Έχετε ήδη λογαριασμό;',
            'Do not forgot to check SPAM box.': 'Μην ξεχάσετε να ελέγξετε και τα ανεπιθύμητα email σας.',
            "Enter your username": "Εισαγάγετε το όνομα χρήστη σας",
            "Enter password": "Εισαγάγετε κωδικό",
            "By Signing up, you agree to our": "Με την εγγραφή σας, συμφωνείτε με τους",
            'Terms of Service': ' Όρους Παροχής Υπηρεσιών',
            'Privacy policy': 'Πολιτική απορρήτου',
            'and': 'και την',

        },
        en: {
            'Access failed!': `Internet Access to ${API} failed! Please check your network and firewall. Access to port ${API_PORT} of domain ${API_DOMAIN} must not be blocked to continue.`,
            "Attempt to read property \"isActive\" on null": "You must first verify your email address to log in. Check your email.",
            reset: 'RESET',
            'reset_password_message': 'Enter your email and follow the instructions.',
            required: 'Required field',
            login: 'LOGIN',
            'Forgot password?': 'Forgot Password?',
            'Don\'t have an account? Sign Up': 'Don\'t have an account?'
        }
    },
    [Namespaces.PAGE_HOME]: {
        el: {
            'Privacy policy': 'Πολιτική απορρήτου',
            'Terms & Conditions': 'Όροι & Προϋποθέσεις',
            'This site is protected by': 'Αυτός ο ιστότοπος προστατεύεται από την ',
            'All rights reserved': 'Διατήρηση δικαιωμάτων',
            'Requests': 'Αιτήσεις',
            'Choose a request': 'Επιλέξτε αίτηση',
            'Submit':'Υποβολή'

        },
        en: {}
    },
    [Namespaces.PAGE_RESET_PASSWORD]: {
        el: {
            'Reset Password': 'Επαναφορά Κωδικού',
            'Enter the six-digit code you received in the email': 'Εισαγάγετε τον εξαψήφιο κωδικό που λάβατε στο email',
            Password: 'Κωδικός',
            'Confirm Password': 'Επαλήθευση Κωδικού',
            'Password changed successfully!': 'Ο κωδικός άλλαξε με επιτυχία!',
            'The six digit number has expired!': 'Ο εξαψήφιος κωδικός έχει λήξει!',
            'Six-digit code send successfully!': 'Ο εξαψήφιος κωδικός στάλθηκε με επιτυχία!',
            'Login with different credentials': 'Σύνδεση με διαφορετικό λογαριασμό',
            'Send me new Code': 'Αποστολή νέου κωδικού',
            'Submit': 'Καταχώριση',
            'Required!': 'Απαιτείται!',
            'Enter exactly 6 characters.': 'Εισαγάγετε ακριβώς 6 χαρακτήρες.',
            'Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character': 'Ο κωδικός πρόσβασης πρέπει να αποτελείται από 7-16 λατινικούς χαρακτήρες και να περιέχει τουλάχιστον 3 από τα ακόλουθα. -Κεφάλαιο -Πεζό χαρακτήρα -Αριθμητικό ψηφίο -Ειδικός χαρακτήρας',
            'Passwords must match': 'Οι κωδικοί πρέπει να ταιριάζουν',
            'Wrong six-digit code!': 'Λάθος εξαψήφιος κωδικός!',
        },
        en: {}
    },
}

export default locales